const RadioOn = () => {
    return <svg id='Component_101_3' data-name='Component 101 – 3' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
        <rect id='rectangle' width='24' height='24' fill='none' />
        <circle id='Ellipse_5' data-name='Ellipse 5' cx='6' cy='6' r='6' transform='translate(6 6)' fill='#404040' />
        <path id='radio_on' d='M12,2A10,10,0,1,0,22,12,10.029,10.029,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8,8.024,8.024,0,0,1-8,8Z' fill='#404040' fillRule='evenodd' />
    </svg>
}

export default RadioOn